$('.wysiwyg-area > table').wrap('<div class="scrollable"></div>');



// WEBPACK FOOTER //
// ./client/src/core/components/wysiwyg/table/tables.js